// Separate function to be able to mock
export function getHostname() {
  return window.location.hostname;
}
